import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import { FiClock } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { Loader } from '@/components/custom/loader';
import { PlayfulContentCard } from '@/components/custom/playful-content-card';
import liveScreenIcon from '@/assets/images/icons/live-screen.png';

export default function LiveClassesHighlights() {
  const client = useClient();
  const navigate = useNavigate();
  const [liveClasses, setLiveClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTodayLiveClasses = async () => {
      setLoading(true);
      try {
        const today = moment().format('YYYY-MM-DD');
        const { data } = await client.fetch(`/live_classrooms?filter[date_between][initial]=${today}&filter[date_between][final]=${today}`);
        const now = moment();
        setLiveClasses((data || []).filter(item => now.isBetween(item['initial-date'], item['end-date'])));
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    fetchTodayLiveClasses();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (liveClasses.length === 0) {
    return (
      <EmptyState
        type="data"
        title="Nenhuma aula ao vivo no momento"
        variant="plain"
        className="pt-32"
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {liveClasses.map(liveClass => (
        <PlayfulContentCard
          key={liveClass.id}
          icon={liveScreenIcon}
          badge={{ text: 'Ao vivo', className: 'bg-[#FF5630]' }}
          title={liveClass.title}
          subtitle={liveClass.courses?.[0]?.name}
          meta={[{ icon: FiClock, text: `${moment(liveClass['initial-date']).format('H[h]')} às ${moment(liveClass['end-date']).format('H[h]')}` }]}
          actionLabel="Acessar"
          onAction={() => navigate(`/aulas-ao-vivo/${liveClass.id}`)}
          onClick={() => navigate(`/aulas-ao-vivo/${liveClass.id}`)}
        />
      ))}
    </div>
  );
}
